import { useEffect } from 'react';
import PropTypes from 'prop-types';

import './AllCardsPage.css';

import { useCard } from '../../hook/useCard';
import { useSet } from '../../hook/useSet';
import Layout from '../../layouts/layouts';
import SetListPanel from './SetListPanel/SetListPanel';
import CardPanel from './CardInfoPanel/CardInfoPanel';
import CardListPanel from './CardListPanel/CardListPanel';

/**
 * List of all existing MTG cards
 * @component
 */
const AllCardsPage = ({ title, layout }) => {
	const { activeSet } = useSet();
	const { activeCard, setActiveCard } = useCard();

	useEffect(() => {
		console.log('Initialization: AllCardsPage');
	}, []);

	useEffect(() => {
		setActiveCard(null);
	}, [activeSet, setActiveCard]);

	return (
		<Layout layout={layout} title={title}>
			<div className="all-cards">
				{activeCard ? <CardPanel /> : <SetListPanel />}

				{activeSet ? <CardListPanel /> : null}
			</div>
		</Layout>
	);
};

AllCardsPage.propTypes = {
	// Page title for the browser tab
	title: PropTypes.string.isRequired,
	// Page Layout
	layout: PropTypes.string.isRequired,
};

export default AllCardsPage;
